import React, { useEffect } from "react";
import './App.css';
import Header from "./Header.js";
import Home from "./Home.js";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Checkout from "./Checkout";
import Login from "./Login.js";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";


function App() {
  const [{}, dispatch] = useStateValue();

  useEffect(() => {
    //will only run once when the app component loads...
    auth.onAuthStateChanged(authUser => {
      console.log('The user is >>>', authUser);

      if(authUser){
        //the user just logged in/ the user is logged in
        dispatch({
          type: 'SET_USER',
          user: authUser
        })

      } else {
        //the user is logged out
        dispatch({
          type: 'SET_USER',
          user: null
        })
      }

    })
  }, [])

  return (
    <Router>
    <div className="app">
    
       <Switch>
       <Route path="/login">
          <Login/>
          </Route>

          <Route path="/checkout">
          <Header />
          <Checkout />
          </Route>

          <Route path="/">
          <Header />
           <Home />
           <h3>Developed by: Abhishek Anjana</h3>
         </Route>

       </Switch>
      
     
    </div>

    </Router>
  );
}

export default App;
